/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import MoserObjectUtils from './MoserObjectUtils';
import PropertyType from './PropertyType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // getList
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // new

/**
 * @author  mohamedelgemaiey Utility class used by LogicalModuleResolver and ResolverUtil This class will be translated into javascript, so think twice before adding new import
 */
export default class CommonResolverUtil extends BaseMoserObject{

	/**
	 * get the place holder in MDTV.
	 * @param {Module} m  nodule.
	 * @param {String} moduleAlias  alias.
	 * @return {FolderType}  place holder or null.
	 */
	static getFMPlaceHolderInMDTV(m, moduleAlias) {
		if (!m) {
			return null;
		}
		return CommonResolverUtil._getPlaceHolder(m.basicGetMetadataTreeView(), moduleAlias);
	}

	static _getPlaceHolder(lst, moduleAlias) {
		if (!lst || lst.length==0) {
			return null;
		}
		var subList = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = lst, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var f = __exp_enFor0[__i_enFor0];
			if (moduleAlias == f.getIdentifier() || f.getIdentifier() == null && f.basicGetPropertyOverride() && f.basicGetPropertyOverride().indexOf(moduleAlias)> -1) {
				return f;
			}
			var fItems = MoserObjectUtils.getList(f.basicGetFolderItem());
			for (var __i_enFor1 = 0, __exp_enFor1 = fItems, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var itm = __exp_enFor1[__i_enFor1];
				var c = itm.getFolder();
				if (c) {
					subList.push(c);
				}
			}
		}
		return CommonResolverUtil._getPlaceHolder(subList, moduleAlias);
	}

	/**
	 * Create a PropertyType with name/value, then add it the ObjectType, return previous property if set.
	 * @param {ObjectType} object
	 * @param {String} name
	 * @param {String} value
	 * @return {PropertyType}  previous PropertyType if set
	 */
	static setProperty(object, name, value) {
		var previous = CommonResolverUtil.removeProperty(object, name);
		var property = new PropertyType();
		property.setName(name);
		property.setValue(value);
		object.addProperty(property);
		return previous;
	}

	/**
	 * Remove a PropertyType with matching name.
	 * @param {ObjectType} object
	 * @param {String} name
	 * @return {PropertyType}  previous PropertyType if set
	 */
	static removeProperty(object, name) {
		var props = MoserObjectUtils.getList(object.basicGetProperty());
		var iter = props.iterator();
		while (iter.hasNext()) {
			var p = iter.next();
			if (p.getName() == name) {
				iter.remove();
				return p;
			}
		}
		return null;
	}

	/**
	 * Get a PropertyType with name.
	 * @param {String} name
	 * @param  value
	 * @return {String}  PropertyType if set
	 */
	static getProperty(object, name) {
		var props = MoserObjectUtils.getList(object.basicGetProperty());
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if (p.getName() == name) {
				return p.getValue();
			}
		}
		return null;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/CommonResolverUtil.js